module.exports = function Translate(translations, language) {

    return (key) => {
        return translations[language][key] || key
    }
};
